import { downloadAppCtaBody, downloadAppCtaTitle } from "@/lib/downloadAppCtaCopy"
import { twMerge } from "tailwind-merge"
import GetAppButtons from "../GetAppButtons"
import BodyDefault from "../text/BodyDefault"
import Heading2 from "../text/Heading2"

type CallToActionProps = {
  bannerText?: string
  forceButtons?: boolean
  className?: string
}

const CallToActionBanner: React.FC<CallToActionProps> = ({ bannerText, forceButtons, className }) => {
  return (
    <div
      className={twMerge(
        "relative bg-purple isolate overflow-hidden py-[4rem] md:p-[4rem] text-center rounded-xl",
        className,
      )}>
      <Heading2 className="text-white">{downloadAppCtaTitle}</Heading2>
      <BodyDefault className="mx-auto px-[1rem] pt-[1.5rem] md:pb-[2rem] md:max-w-3xl text-white font-bold text-[1rem] leading-1.5">
        {bannerText ?? downloadAppCtaBody}
      </BodyDefault>
      <div className="px-[0.3rem]">
        <GetAppButtons size="small" forceButtons={forceButtons} />
      </div>
    </div>
  )
}

export default CallToActionBanner
